module.exports = __webpack_public_path__ + "img/H5.c7101bff.png";